import {useParams} from '@aboutyou/router';
import {getEntityIdFromRouteParam} from '@aboutyou/utils';

export const useStoryClusterIdFromUrl = () => {
  const {storyClusterId: storyClusterPath} = useParams<{
    storyClusterId: string;
  }>();
  const storyClusterId = getEntityIdFromRouteParam(storyClusterPath);
  return storyClusterId ? Number(storyClusterId) : undefined;
};
